export default __webpack_public_path__ + "static/JK2-e22dd4612215bdb82465d6cfdc689d07.png";